<template>
  <chip :label="state" :class="classname"/>
</template>

<script>
import Chip from 'primevue/chip'
import SpeakerState from '../../enums/speaker-state'
export default {
  name: 'SpeakerStateDisplay',
  components: {
    Chip
  },
  props: {
    state: {
      type: String,
      required: true
    }
  },
  computed: {
    classname () {
      switch (this.state) {
        case SpeakerState.PENDING:
          return 'speaker-state-display-pending'
        case SpeakerState.ACTIVE:
          return 'speaker-state-display-active'
        case SpeakerState.SPOKEN:
          return 'speaker-state-display-spoken'
        case SpeakerState.WITHDRAWN:
          return 'speaker-state-display-withdrawn'
      }
    }
  }
}
</script>

<style scoped>
.speaker-state-display-pending {
  background-color: #e9e9ff;
  color: #696cff;
}
.speaker-state-display-active {
  background-color: #e4f8f0;
  color: #1ea97c;
}
.speaker-state-display-spoken {
  background-color: #fff2e2;
  color: #cc8925;
}
.speaker-state-display-withdrawn {
  background-color: #ffe7e6;
  color: #ff5757;
}
</style>



// WEBPACK FOOTER //
// src/components/speakers/SpeakerStateDisplay.vue